import { clients } from '@/mocks/clients';

export default function ClientLogosStrip() {
  const doubled = [...clients, ...clients, ...clients];

  return (
    <div className="w-full overflow-hidden py-4 md:py-5 border-b border-white/10 relative z-10">
      <div className="text-center mb-3 md:mb-4">
        <span className="relative inline-flex items-center gap-2.5 text-[11px] md:text-xs font-medium text-white/30 uppercase tracking-[0.18em]">
          <span className="w-5 h-px bg-white/15"></span>
          Trusted by 10+ industry leaders
          <span className="w-5 h-px bg-white/15"></span>
        </span>
      </div>

      <div className="relative group overflow-hidden py-2">
        {/* Left luminous fade */}
        <div className="absolute left-0 top-0 bottom-0 w-16 sm:w-24 md:w-32 bg-gradient-to-r from-navy-900 via-navy-900/80 to-transparent z-10 pointer-events-none"></div>
        {/* Left glow accent */}
        <div className="absolute left-0 top-1/2 -translate-y-1/2 w-16 h-24 bg-primary-500/10 blur-2xl z-[5] pointer-events-none"></div>

        {/* Right luminous fade */}
        <div className="absolute right-0 top-0 bottom-0 w-16 sm:w-24 md:w-32 bg-gradient-to-l from-navy-900 via-navy-900/80 to-transparent z-10 pointer-events-none"></div>
        {/* Right glow accent */}
        <div className="absolute right-0 top-1/2 -translate-y-1/2 w-16 h-24 bg-amber-500/10 blur-2xl z-[5] pointer-events-none"></div>

        <div
          className="flex gap-5 md:gap-7 animate-marquee-left items-center"
          style={{ animationDuration: '55s' }}
        >
          {doubled.map((client, i) => (
            <div
              key={`${client.name}-${i}`}
              className="flex-shrink-0 group/card relative cursor-default"
            >
              <div className="flex flex-col items-center gap-2 transition-all duration-500 group-hover/card:-translate-y-1">
                <div className="w-100 h-28 md:w-100 md:h-28 rounded-2xl overflow-hidden border border-white/10 group-hover/card:border-white/25 transition-all duration-500 relative bg-white/5">
                  <img
                    src={client.image}
                    alt={`${client.name} logo`}
                    className="w-full h-full object-cover opacity-70 group-hover/card:opacity-100 transition-opacity duration-500"
                    loading="lazy"
                    draggable={false}
                  />
                  {/* Glow ring on hover */}
                  <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-primary-400/0 group-hover/card:ring-primary-400/30 transition-all duration-500"></div>
                </div>
                {/* Name reveal on hover */}
                <span className="text-[10px] md:text-[11px] font-semibold text-white/0 group-hover/card:text-white/60 transition-all duration-300 -translate-y-1 group-hover/card:translate-y-0 whitespace-nowrap">
                  {client.name}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}